module.exports = __webpack_public_path__ + "img/dogs.51b24688.jpeg";